export type AuthUser = {
  id: string;
  email: string;
  name: string;
};

export function getStoredUser(): AuthUser | null {
  const raw = localStorage.getItem("user");
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthUser;
  } catch {
    return null;
  }
}

export function storeAuth(token: string, user: AuthUser): void {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
}

export function clearAuth(): void {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
}

export function isTokenExpired(): boolean {
  const token = localStorage.getItem("token");
  if (!token) return true;
  try {
    const [, payload] = token.split(".");
    const decoded = JSON.parse(atob(payload)) as { exp: number };
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}
